var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"business-contact-topic-edit","toptitle":"Schwerpunkt bearbeiten","title":_vm.businessContactTopic.name,"width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('business-contact-topic-form',{attrs:{"businessContactTopic":_vm.businessContactTopic,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }